import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D68EF8DE-C9F5-47FB-BCD4-C0DD4D7FCBFD
 * name spoon-sugar
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spoon-sugar.svg
 * tags
 * - Food / Drink 
 */
export const SpoonSugarIcon = createSvgIcon(<><path d="M6 13H3V10H6V13M10 10H7V13H10V10M8 6H5V9H8V6M18 12C14.25 12 12.28 13.25 11 14H2C2 16.21 3.79 18 6 18H7C8 18 8.92 17.63 9.62 17C11.06 15.78 12.68 14.74 14.55 14.36C15.61 14.15 16.78 14 18 14H22V12H18Z" /></>, 'SpoonSugarIcon');
export default SpoonSugarIcon